export const getRoomUrl : (roomId: number, roomName: string) => string = (roomId, roomName) => {
  return `/room/${roomId}-${roomName.replace(/\s+/g, ' ').replace(/\s/g, '-')}`.toLowerCase()
}